import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DeskIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DeskIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.8606 4.87439H2.85883C2.59647 4.87439 2.38379 5.08707 2.38379 5.34943V7.24961C2.38379 7.51197 2.59647 7.72465 2.85883 7.72465H3.33387V18.6507C3.33387 18.913 3.54655 19.1257 3.80891 19.1257C4.07127 19.1257 4.28395 18.913 4.28395 18.6507V7.72466H11.8846V18.6507C11.8846 18.913 12.0973 19.1257 12.3597 19.1257H20.9105C21.1728 19.1257 21.3855 18.913 21.3855 18.6507V7.72466H21.8606C22.1229 7.72466 22.3356 7.51198 22.3356 7.24962V5.34944C22.3356 5.08708 22.1229 4.87439 21.8606 4.87439ZM20.4355 14.3753H12.8348V11.525H20.4355V14.3753ZM20.4355 18.1756H12.8348V15.3254H20.4355V18.1756ZM20.4355 10.5749H12.8348V7.72466H20.4355V10.5749ZM21.3855 6.77457H3.33388V5.82448H21.3855V6.77457Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1601 9.62525H17.1102C17.3725 9.62525 17.5852 9.41257 17.5852 9.15021C17.5852 8.88785 17.3725 8.67517 17.1102 8.67517H16.1601C15.8977 8.67517 15.6851 8.88785 15.6851 9.15021C15.6851 9.41257 15.8977 9.62525 16.1601 9.62525Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1601 13.4251H17.1102C17.3725 13.4251 17.5852 13.2124 17.5852 12.95C17.5852 12.6877 17.3725 12.475 17.1102 12.475H16.1601C15.8977 12.475 15.6851 12.6877 15.6851 12.95C15.6851 13.2124 15.8977 13.4251 16.1601 13.4251Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.1601 17.2258H17.1102C17.3725 17.2258 17.5852 17.0132 17.5852 16.7508C17.5852 16.4884 17.3725 16.2758 17.1102 16.2758H16.1601C15.8977 16.2758 15.6851 16.4884 15.6851 16.7508C15.6851 17.0132 15.8977 17.2258 16.1601 17.2258Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DeskIcon;
